/**
 * Funkcja tworząca GUIDa
 * @returns {GUID} 
 */

export function Guid(): string
{
    var array = new Uint16Array(8);
    (window.crypto || window.Crypto).getRandomValues(array);
    var dataView = new DataView(array.buffer);

    var parts = [];

    for(var i = 0; i < array.length; ++i)
    {
        // 0&1,2,3,4,5-7 dataView.getUint16(0-7)
        if(i>1 && i<6) parts.push("-");
        parts.push(dataView.getUint16(i).toString(16).padStart(4, '0'));
    }

    parts[5] = "4" + parts[5].substr(1);
    return parts.join('').toLowerCase();// .toUpperCase();
}